import React from "react";
import styled from "styled-components";
import { Card, Colors, Intent, Tag } from "@blueprintjs/core";
import { Box } from "ui-components";

type Props = {
  className?: string;
  interactive?: boolean;
  avatarIcon?: string;
  chipLabel?: string;
  chipStatus?: Intent;
  children: React.ReactNode;
  imageWidth?: string;
};
const HorizontalCard = (props: Props) => {
  const {
    className = "",
    interactive = false,
    avatarIcon,
    chipLabel = null,
    chipStatus = "success",
    children = null,
    imageWidth = "50",
  } = props;
  return (
    <CustomCard className={className} interactive={interactive}>
      <Box flexDir="row" items="start">
        {avatarIcon && (
          <div className="mr-sm">
            <img src={avatarIcon} alt="" width={imageWidth} />
          </div>
        )}
        <TextContainer>{children}</TextContainer>
      </Box>
      {chipLabel && (
        <Chip>
          <Tag round={true} large={true} intent={chipStatus} minimal={true}>
            {chipLabel}
          </Tag>
        </Chip>
      )}
    </CustomCard>
  );
};

export default HorizontalCard;

const Chip = styled.span`
  float: right;
  margin-right:5px;
  margin-top:-15px;
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY4 : Colors.GRAY2};
`;

const CustomCard = styled(Card)`
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  width: 100%;
`;


export const Amount = styled.span`
  font-size: 18px;
  font-weight: 600;
`;

export const Label = styled.span`
  font-size: 15px;
  color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY5 : Colors.GRAY1};
  // line-height: 1.7em;
  margin-top:3px;
`;